import { render, staticRenderFns } from "./RecipientHealth.vue?vue&type=template&id=b6816b36&"
import script from "./RecipientHealth.vue?vue&type=script&lang=js&"
export * from "./RecipientHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports